import { render, staticRenderFns } from "./WorkForm.vue?vue&type=template&id=154624b4&scoped=true"
import script from "./WorkForm.vue?vue&type=script&lang=js"
export * from "./WorkForm.vue?vue&type=script&lang=js"
import style0 from "./WorkForm.vue?vue&type=style&index=0&id=154624b4&prod&scoped=true&lang=css"
import style1 from "./WorkForm.vue?vue&type=style&index=1&id=154624b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154624b4",
  null
  
)

export default component.exports